import { PureComponent, ReactNode } from 'react';

class BetaTag extends PureComponent {
    render(): ReactNode {
        return (
            <p
                className="text-10 font-700 text-white rounded-4 px-4 py-2"
                style={{
                    background: 'linear-gradient(99deg, #19A66A 4.28%, #247E39 96.85%)',
                }}
            >
                BETA
            </p>
        );
    }
}

export default BetaTag;
